import { getLiabilityPolicyLimitsLabel, getMajorMedCarrierTypeText, getMedPayPolicyLimitsLabel, getUmPolicyLimitsLabel } from "../../../lib/labels"
import { formatCurrency, traverseObject } from "../../../lib/script"
import GoToDetailsTab from "../pages/custom/GoToDetailsTab"
import VerificationBox from "../pages/custom/VerificationBox"

import classes from './VerificationCell.module.css'

export default function VerificationCell({item, sub_item, workqSlug}) {

    const liabilityIgnoreFields = ['com_dui_hr']

    return <>
        {item && sub_item && <>
            {/* liability limit  */}
            {sub_item.key == 'liability_verification' && item.liability && traverseObject(item.liability, liabilityIgnoreFields) && <GoToDetailsTab tabNumber={1} workqSlug={workqSlug} caseId={item?.patient.person_number}>
                <VerificationBox displayData={getLiabilityPolicyLimitsLabel(item.liability.policy_limit_patient)} rowData={item} type={'liability'} folderData={item.liability}/>
            </GoToDetailsTab>}
            {sub_item.key == 'liability_verification' && (!item.liability || !traverseObject(item.liability)) && <div className={classes.no_data}></div>}

            {/* mp amount  */}
            {sub_item.key == 'mp_verification' && item.mp_pip && traverseObject(item.mp_pip) && <GoToDetailsTab tabNumber={2} workqSlug={workqSlug} caseId={item?.patient.person_number}>
                <VerificationBox displayData={getMedPayPolicyLimitsLabel(item.mp_pip.mp_policy_limit)} rowData={item} type={'medpay'} isPIP={true} folderData={item.mp_pip}/>
            </GoToDetailsTab>}
            {sub_item.key == 'mp_verification' && (!item.mp_pip || !traverseObject(item.mp_pip)) && <div className={classes.no_data}></div>}

            {/* um amount  */}
            {sub_item.key == 'um_verification' && item.um && item.liability && traverseObject(item.um) && <GoToDetailsTab tabNumber={3} workqSlug={workqSlug} caseId={item?.patient.person_number}>
                <VerificationBox displayData={getUmPolicyLimitsLabel(item.um.um_policy_limit_patient)} rowData={item} type={'um'} folderData={item.um}/>
            </GoToDetailsTab>}
            {sub_item.key == 'um_verification' && (!item.um || !traverseObject(item.um)) && <div className={classes.no_data}></div>}

            {/* mm carier types */}
            {sub_item.key == 'major_med_verification' && item.major_med && traverseObject(item.major_med) && <GoToDetailsTab tabNumber={5} workqSlug={workqSlug} caseId={item?.patient.person_number}>
                <VerificationBox displayData={getMajorMedCarrierTypeText(item.major_med.carrier_types)} rowData={item} type={'majormed'} lastCell={true} folderData={item.major_med}/>
            </GoToDetailsTab>}
            {sub_item.key == 'major_med_verification' && (!item.major_med || !traverseObject(item.major_med)) && <div className={classes.no_data}></div>}

            {/* transportation  */}
            {sub_item.key == 'transportation_funds_remaining' && item.case_transportation && traverseObject(item.case_transportation) && <GoToDetailsTab tabNumber={8} workqSlug={workqSlug} caseId={item?.patient.person_number}>
                <VerificationBox displayData={`$${formatCurrency(item.case_transportation.funds_remaining)}`} rowData={item} type={'transportation'} folderData={item.case_transportation}/>
            </GoToDetailsTab>}
        
        </>}
    </>
}